import { AppContext } from "../AppDataProvider/AppDataProvider";
import ModalDialog from "./ModalDialog/ModalDialog";
import NonModalDialog from "./NonModalDialog/NonModalDialog";
import React from "react";
import { ToastArea } from "./ToastArea/ToastArea";
import { useContext } from "react";
export function NotificationsAndDialogs() {
  const {
    appData
  } = useContext(AppContext);
  const {
    modalDialog,
    nonModalDialog
  } = appData;
  return <>
      <ToastArea data-sentry-element="ToastArea" data-sentry-source-file="NotificationsAndDialogs.tsx" />
      {modalDialog !== undefined && <ModalDialog />}
      {nonModalDialog !== undefined && <NonModalDialog />}
    </>;
}